import { FlexRow, ListItem, ListLabel, ListCount, Heading, CustomLine } from "./MetricDashboard.styles";
import PropTypes from "prop-types";

const VCCPDashboardCount = ({ dashboardCountData }) => {
  return (
    <>
      <Heading style={{ fontSize: "22px", fontWeight: "bold" }}>Case Support Type Data</Heading>
      <CustomLine type="light"></CustomLine>
      {dashboardCountData && dashboardCountData?.typeCountList?.length > 0 ? (
        <FlexRow>
          {dashboardCountData?.typeCountList.map((dashboardData) => {
            return (
              <ListItem key={dashboardData?.type}>
                <ListLabel>{dashboardData?.type || ""}</ListLabel>
                <ListCount>{dashboardData?.count || ""}</ListCount>
              </ListItem>
            );
          })}
        </FlexRow>
      ) : (
        <FlexRow>No Data Available</FlexRow>
      )}{" "}
      <Heading style={{ fontSize: "22px", fontWeight: "bold" }}>Case Support Status Data</Heading>
      <CustomLine type="light"></CustomLine>
      {dashboardCountData && dashboardCountData?.statusCountList?.length > 0 ? (
        <FlexRow>
          {dashboardCountData?.statusCountList.map((dashboardData) => {
            return (
              <ListItem key={dashboardData?.status}>
                <ListLabel>{dashboardData?.status || ""}</ListLabel>
                <ListCount>{dashboardData?.count || ""}</ListCount>
              </ListItem>
            );
          })}
        </FlexRow>
      ) : (
        <FlexRow>No Data Available</FlexRow>
      )}
    </>
  );
};

VCCPDashboardCount.propTypes = {
  dashboardCountData: PropTypes.object.isRequired,
};

export default VCCPDashboardCount;
